import React from 'react'
import FeatureNotImplemented from '../FeatureNotImplemented/FeatureNotImplemented'

const Documentation = () => {
  return (
    <div><FeatureNotImplemented msg="Documentation"/></div>
  )
}

export default Documentation